<app-work-suggestion-page class="pt-2 subpage-content"
    [suggestionTypeInput]="suggestionType"
    [personIdInput]="folderStore.folder()?.personId || null"
    (closeCallback)="dialogRef.close()"
></app-work-suggestion-page>

<div #dialogFooter></div>
